import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ClientList from "@/pages/ClientList";
import NewClient from "@/pages/NewClient";
import JobPage from "@/pages/JobPage";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import ResultsLog from "@/pages/ResultsLog";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/clients" replace />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/clients/new" element={<NewClient />} />
          <Route path="/jobs/:jobId" element={<JobPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/audit" element={<AuditLog />} />
          <Route path="/results" element={<ResultsLog />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
